import Vue from 'vue';
import Vuex from 'vuex';
import axios, { axiosM } from '@/plugins/axios';
import AccessModule from './views/access/access.store';

Vue.use(Vuex);
const store = new Vuex.Store<any>({
  state: {
    user: {
      username: '',
      治未病数据中心: false,
      中医影像数据中心: false,
      数据中心: {},
      分析挖掘: {},
      AI训练: {},
    },
    token: '',
    researchListComposeDiabled: true,
    ifCompose: false,
    edrIfCompose: false,
    ossClient: {},
    center: {},
    roleControl: {
      '批量导出': ['项目负责人', '课题负责人'],
      '数据录入': ['项目负责人', '课题负责人', '分中心负责人', '主要研究者', '研究者'],
      '质疑': ['监查员', '质量审核员'],
      '审核通过': ['监查员', '质量审核员'],
      '监查痕迹': ['项目负责人', '监查员', '课题负责人', '分中心负责人'],
    }
  },
  mutations: {
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateUser(state, data) {
      state.user = data;
    },
    updateResearchListComposeDiabled(state, ifDisable) {
      state.researchListComposeDiabled = ifDisable;
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updateEdrIfCompose(state, ifCompose) {
      state.edrIfCompose = ifCompose;
    },
    updateOss(state, newOss) {
      state.ossClient = newOss;
    },
    updateCenter(state, center) {
      state.center = center;
    }
  },
  actions: {
    async login({ commit, dispatch }, payload) {
      try {
        const { data } = await axios.post("api/user/login", payload);
        if (data.data) {
          commit('updateToken', data.data.token);
          // 返回dispatch保证login页面中能按顺序执行
          return dispatch('getUser');
        } else {
          return new Promise((resolve, reject) => {
            reject(data.msg);
          });
        }
      } catch (e) {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      }

    },
    async getUser({ commit }) {
      const { data } = await axios.get('api/user');
      commit('updateUser', data.data);
    },
  },
  modules: {
    access: AccessModule
  }
});

export default store;
